export default __webpack_public_path__ + "8ca27a903875fafc9e4559113bf980e8.svg";